import permissions from '@constants/enums/auth/permission';

import i18n from '@plugins/i18n';

export default [
    {
        path: '/system/events',
        name: 'SystemEvents',
        component: () => import('@/views/SystemEvents.vue'),
        meta: {
            overline: i18n.t('system'),
            title: i18n.t('events'),
            heading: i18n.t('events'),
            permissions: [permissions.BULK_IMPORT],
            organisations: ['ADVISER']
        }
    },
    {
        path: '/system/data-entry',
        name: 'SystemDataEntry',
        components: {
            default: () => import('@/views/SystemDataEntry.vue'),
            sidebar: () => import('@/components/sidebars/SystemDataEntrySidebar.vue')
        },
        meta: {
            overline: i18n.t('system'),
            title: i18n.t('data_entry'),
            heading: i18n.t('data_entry'),
            permissions: [permissions.BULK_IMPORT],
            organisations: ['ADVISER'],
            sidebarKey: 'system-data-entry-sidebar'
        },
        children: [
            {
                path: 'activity',
                name: 'SystemDataEntryActivity',
                component: () => import('@/views/SystemDataEntryActivity.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('activity'),
                    heading: i18n.t('activity'),
                    permissions: [permissions.ANY_USER_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'activity/create/:id?',
                name: 'SystemDataEntryActivityCreate',
                component: () => import('@/views/SystemDataEntryActivityCreate.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('create') + ' ' + i18n.t('activity'),
                    heading: i18n.t('create') + ' ' + i18n.t('activity'),
                    permissions: [permissions.ANY_USER_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'activity/edit/:id',
                name: 'SystemDataEntryActivityEdit',
                component: () => import('@/views/SystemDataEntryActivityEdit.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('edit') + ' ' + i18n.t('activity'),
                    heading: i18n.t('edit') + ' ' + i18n.t('activity'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'users',
                name: 'SystemDataEntryUsers',
                component: () => import('@/views/SystemDataEntryUsers.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('users'),
                    heading: i18n.t('users'),
                    permissions: [permissions.ANY_USER_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'users/create/:id?',
                name: 'SystemDataEntryUsersCreate',
                component: () => import('@/views/SystemDataEntryUsersCreate.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('create') + ' ' + i18n.t('user'),
                    heading: i18n.t('create') + ' ' + i18n.t('user'),
                    permissions: [permissions.ANY_USER_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'users/edit/:id',
                name: 'SystemDataEntryUsersEdit',
                component: () => import('@/views/SystemDataEntryUsersEdit.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('edit') + ' ' + i18n.t('user'),
                    heading: i18n.t('edit') + ' ' + i18n.t('user'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'advisers',
                name: 'SystemDataEntryAdvisers',
                component: () => import('@/views/SystemDataEntryAdvisers.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('advisers'),
                    heading: i18n.t('advisers'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'advisers/create/:id?',
                name: 'SystemDataEntryAdvisersCreate',
                component: () => import('@/views/SystemDataEntryAdvisersCreate.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('create') + ' ' + i18n.t('adviser'),
                    heading: i18n.t('create') + ' ' + i18n.t('adviser'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'advisers/edit/:id',
                name: 'SystemDataEntryAdvisersEdit',
                component: () => import('@/views/SystemDataEntryAdvisersEdit.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('edit') + ' ' + i18n.t('adviser'),
                    heading: i18n.t('edit') + ' ' + i18n.t('adviser'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'companies',
                name: 'SystemDataEntryCompanies',
                component: () => import('@/views/SystemDataEntryCompanies.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('companies'),
                    heading: i18n.t('companies'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'companies/create/:id?',
                name: 'SystemDataEntryCompaniesCreate',
                component: () => import('@/views/SystemDataEntryCompaniesCreate.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('create') + ' ' + i18n.t('company'),
                    heading: i18n.t('create') + ' ' + i18n.t('company'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'companies/edit/:id',
                name: 'SystemDataEntryCompaniesEdit',
                component: () => import('@/views/SystemDataEntryCompaniesEdit.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('edit') + ' ' + i18n.t('company'),
                    heading: i18n.t('edit') + ' ' + i18n.t('company'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'fee-plans',
                name: 'SystemDataEntryFeePlans',
                component: () => import('@/views/SystemDataEntryFeePlans.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('fee_plans'),
                    heading: i18n.t('fee_plans'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'fee-plans/create/:id?',
                name: 'SystemDataEntryFeePlansCreate',
                component: () => import('@/views/SystemDataEntryFeePlansCreate.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('create') + ' ' + i18n.t('fee') + ' ' + i18n.t('plan'),
                    heading: i18n.t('create') + ' ' + i18n.t('fee') + ' ' + i18n.t('plan'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'fee-plans/edit/:id',
                name: 'SystemDataEntryFeePlansEdit',
                component: () => import('@/views/SystemDataEntryFeePlansEdit.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('edit') + ' ' + i18n.t('fee') + ' ' + i18n.t('plan'),
                    heading: i18n.t('edit') + ' ' + i18n.t('fee') + ' ' + i18n.t('plan'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'rate-plans',
                name: 'SystemDataEntryRatePlans',
                component: () => import('@/views/SystemDataEntryRatePlans.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('rate_plans'),
                    heading: i18n.t('rate_plans'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'rate-plans/create/:id?',
                name: 'SystemDataEntryRatePlansCreate',
                component: () => import('@/views/SystemDataEntryRatePlansCreate.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('create') + ' ' + i18n.t('rate_plan'),
                    heading: i18n.t('create') + ' ' + i18n.t('rate_plan'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'rate-plans/edit/:id',
                name: 'SystemDataEntryRatePlansEdit',
                component: () => import('@/views/SystemDataEntryRatePlansEdit.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('edit') + ' ' + i18n.t('rate_plan'),
                    heading: i18n.t('edit') + ' ' + i18n.t('rate_plan'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'subscriptions',
                name: 'SystemDataEntrySubscriptions',
                component: () => import('@/views/SystemDataEntrySubscriptions.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('subscriptions'),
                    heading: i18n.t('subscriptions'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'fund-managers',
                name: 'SystemDataEntryFundManagers',
                component: () => import('@/views/SystemDataEntryFundManagers.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('fund_managers'),
                    heading: i18n.t('fund_managers'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'fund-managers/create/:id?',
                name: 'SystemDataEntryFundManagersCreate',
                component: () => import('@/views/SystemDataEntryFundManagersCreate.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('create') + ' ' + i18n.t('fund_manager'),
                    heading: i18n.t('create') + ' ' + i18n.t('fund_manager'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'fund-managers/edit/:id',
                name: 'SystemDataEntryFundManagersEdit',
                component: () => import('@/views/SystemDataEntryFundManagersEdit.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('edit') + ' ' + i18n.t('fund_manager'),
                    heading: i18n.t('edit') + ' ' + i18n.t('fund_manager'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'funds',
                name: 'SystemDataEntryFunds',
                component: () => import('@/views/SystemDataEntryFunds.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('funds'),
                    heading: i18n.t('funds'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'funds/create/:id?',
                name: 'SystemDataEntryFundsCreate',
                component: () => import('@/views/SystemDataEntryFundsCreate.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('create') + ' ' + i18n.t('fund'),
                    heading: i18n.t('create') + ' ' + i18n.t('fund'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'funds/edit/:id',
                name: 'SystemDataEntryFundsEdit',
                component: () => import('@/views/SystemDataEntryFundsEdit.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('edit') + ' ' + i18n.t('fund'),
                    heading: i18n.t('edit') + ' ' + i18n.t('fund'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'holdings',
                name: 'SystemDataEntryHoldings',
                component: () => import('@/views/SystemDataEntryHoldings.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('holdings'),
                    heading: i18n.t('holdings'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'holdings/edit/:id',
                name: 'SystemDataEntryHoldingsEdit',
                component: () => import('@/views/SystemDataEntryHoldingsEdit.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('edit') + ' ' + i18n.t('holding'),
                    heading: i18n.t('edit') + ' ' + i18n.t('holding'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'investors',
                name: 'SystemDataEntryInvestors',
                component: () => import('@/views/SystemDataEntryInvestors.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('investors'),
                    heading: i18n.t('investors'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'investors/create/:id?',
                name: 'SystemDataEntryInvestorsCreate',
                component: () => import('@/views/SystemDataEntryInvestorsCreate.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('create') + ' ' + i18n.tc('investor'),
                    heading: i18n.t('create') + ' ' + i18n.tc('investor'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'investors/edit/:id',
                name: 'SystemDataEntryInvestorsEdit',
                component: () => import('@/views/SystemDataEntryInvestorsEdit.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('edit') + ' ' + i18n.tc('investor'),
                    heading: i18n.t('edit') + ' ' + i18n.tc('investor'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'offers',
                name: 'SystemDataEntryOffers',
                component: () => import('@/views/SystemDataEntryOffers.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('offers'),
                    heading: i18n.t('offers'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'offers/create',
                name: 'SystemDataEntryOffersCreate',
                component: () => import('@/views/SystemDataEntryOffersCreate.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('create') + ' ' + i18n.tc('offer'),
                    heading: i18n.t('create') + ' ' + i18n.tc('offer'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'offers/edit/:id',
                name: 'SystemDataEntryOffersEdit',
                component: () => import('@/views/SystemDataEntryOffersEdit.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('edit') + ' ' + i18n.tc('offer'),
                    heading: i18n.t('edit') + ' ' + i18n.tc('offer'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'products',
                name: 'SystemDataEntryProducts',
                component: () => import('@/views/SystemDataEntryProducts.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('products'),
                    heading: i18n.t('products'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'products/create/:id?',
                name: 'SystemDataEntryProductsCreate',
                component: () => import('@/views/SystemDataEntryProductsCreate.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('create') + ' ' + i18n.t('product'),
                    heading: i18n.t('create') + ' ' + i18n.t('product'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'products/edit/:id',
                name: 'SystemDataEntryProductsEdit',
                component: () => import('@/views/SystemDataEntryProductsEdit.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('edit') + ' ' + i18n.t('product'),
                    heading: i18n.t('edit') + ' ' + i18n.t('product'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'providers',
                name: 'SystemDataEntryProviders',
                component: () => import('@/views/SystemDataEntryProviders.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('providers'),
                    heading: i18n.t('providers'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'providers/create/:id?',
                name: 'SystemDataEntryProvidersCreate',
                component: () => import('@/views/SystemDataEntryProvidersCreate.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('create') + ' ' + i18n.t('provider'),
                    heading: i18n.t('create') + ' ' + i18n.t('provider'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'providers/edit/:id',
                name: 'SystemDataEntryProvidersEdit',
                component: () => import('@/views/SystemDataEntryProvidersEdit.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('edit') + ' ' + i18n.t('provider'),
                    heading: i18n.t('edit') + ' ' + i18n.t('provider'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'receiving-agents',
                name: 'SystemDataEntryReceivingAgents',
                component: () => import('@/views/SystemDataEntryReceivingAgents.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('receiving_agent'),
                    heading: i18n.t('receiving_agent'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'receiving-agents/create/:id?',
                name: 'SystemDataEntryReceivingAgentsCreate',
                component: () => import('@/views/SystemDataEntryReceivingAgentsCreate.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('create') + ' ' + i18n.t('receiving_agent'),
                    heading: i18n.t('create') + ' ' + i18n.t('receiving_agent'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'receiving-agents/edit/:id',
                name: 'SystemDataEntryReceivingAgentsEdit',
                component: () => import('@/views/SystemDataEntryReceivingAgentsEdit.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('edit') + ' ' + i18n.t('receiving_agent'),
                    heading: i18n.t('edit') + ' ' + i18n.t('receiving_agent'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'registrars',
                name: 'SystemDataEntryRegistrars',
                component: () => import('@/views/SystemDataEntryRegistrars.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('registrars'),
                    heading: i18n.t('registrars'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'registrars/create/:id?',
                name: 'SystemDataEntryRegistrarsCreate',
                component: () => import('@/views/SystemDataEntryRegistrarsCreate.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('create') + ' ' + i18n.t('registrar'),
                    heading: i18n.t('create') + ' ' + i18n.t('registrar'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'registrars/edit/:id',
                name: 'SystemDataEntryRegistrarsEdit',
                component: () => import('@/views/SystemDataEntryRegistrarsEdit.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('edit') + ' ' + i18n.t('registrar'),
                    heading: i18n.t('edit') + ' ' + i18n.t('registrar'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'accounts',
                name: 'SystemDataEntryAccounts',
                component: () => import('@/views/SystemDataEntryAccounts.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('accounts'),
                    heading: i18n.t('accounts'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'accounts/create/:id?',
                name: 'SystemDataEntryAccountsCreate',
                component: () => import('@/views/SystemDataEntryAccountsCreate.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('create') + ' ' + i18n.t('account'),
                    heading: i18n.t('create') + ' ' + i18n.t('account'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'accounts/edit/:id',
                name: 'SystemDataEntryAccountsEdit',
                component: () => import('@/views/SystemDataEntryAccountsEdit.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('edit') + ' ' + i18n.t('account'),
                    heading: i18n.t('edit') + ' ' + i18n.t('account'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'transactions',
                name: 'SystemDataEntryTransactions',
                component: () => import('@/views/SystemDataEntryTransactions.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('transactions'),
                    heading: i18n.t('transactions'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'transactions/create/:id?',
                name: 'SystemDataEntryTransactionsCreate',
                component: () => import('@/views/SystemDataEntryTransactionsCreate.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('create') + ' ' + i18n.t('transaction'),
                    heading: i18n.t('create') + ' ' + i18n.t('transaction'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'transactions/edit/:id',
                name: 'SystemDataEntryTransactionsEdit',
                component: () => import('@/views/SystemDataEntryTransactionsEdit.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('edit') + ' ' + i18n.t('transaction'),
                    heading: i18n.t('edit') + ' ' + i18n.t('transaction'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'custodians',
                name: 'SystemDataEntryCustodians',
                component: () => import('@/views/SystemDataEntryCustodians.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('custodians'),
                    heading: i18n.t('custodians'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'custodians/create/:id?',
                name: 'SystemDataEntryCustodiansCreate',
                component: () => import('@/views/SystemDataEntryCustodiansCreate.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('create') + ' ' + i18n.t('custodian'),
                    heading: i18n.t('create') + ' ' + i18n.t('custodian'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'custodians/edit/:id',
                name: 'SystemDataEntryCustodiansEdit',
                component: () => import('@/views/SystemDataEntryCustodiansEdit.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('edit') + ' ' + i18n.t('custodian'),
                    heading: i18n.t('edit') + ' ' + i18n.t('custodian'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'nominees',
                name: 'SystemDataEntryNominees',
                component: () => import('@/views/SystemDataEntryNominees.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('nominees'),
                    heading: i18n.t('nominees'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'nominees/create/:id?',
                name: 'SystemDataEntryNomineesCreate',
                component: () => import('@/views/SystemDataEntryNomineesCreate.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('create') + ' ' + i18n.t('nominee'),
                    heading: i18n.t('create') + ' ' + i18n.t('nominee'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'nominees/edit/:id',
                name: 'SystemDataEntryNomineesEdit',
                component: () => import('@/views/SystemDataEntryNomineesEdit.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('edit') + ' ' + i18n.t('nominee'),
                    heading: i18n.t('edit') + ' ' + i18n.t('nominee'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'tranche',
                name: 'SystemDataEntryTranches',
                component: () => import('@/views/SystemDataEntryTranches.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('tranches'),
                    heading: i18n.t('tranches'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'tranche/create/:id?',
                name: 'SystemDataEntryTranchesCreate',
                component: () => import('@/views/SystemDataEntryTranchesCreate.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('create') + ' ' + i18n.t('tranche'),
                    heading: i18n.t('create') + ' ' + i18n.t('tranche'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'tranche/edit/:id',
                name: 'SystemDataEntryTranchesEdit',
                component: () => import('@/views/SystemDataEntryTranchesEdit.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('edit') + ' ' + i18n.t('tranche'),
                    heading: i18n.t('edit') + ' ' + i18n.t('tranche'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'registrations',
                name: 'SystemDataEntryRegistrations',
                component: () => import('@/views/SystemDataEntryRegistrations.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('registrations'),
                    heading: i18n.t('registrations'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'registrations/edit/:id',
                name: 'SystemDataEntryRegistrationsEdit',
                component: () => import('@/views/SystemDataEntryRegistrationsEdit.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('edit') + ' ' + i18n.t('registration'),
                    heading: i18n.t('edit') + ' ' + i18n.t('registration'),
                    permissions: [permissions.ANY_ORGANISATION_CREATE],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'agreements',
                name: 'SystemDataEntryAgreements',
                component: () => import('@/views/SystemDataEntryAgreements.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('agreements'),
                    heading: i18n.t('agreements'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'remote-applications',
                name: 'SystemDataEntryRemoteApplications',
                component: () => import('@/views/SystemDataEntryRemoteApplications.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('remote_applications'),
                    heading: i18n.t('remote_applications'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'terms',
                name: 'SystemDataEntryTerms',
                component: () => import('@/views/SystemDataEntryTerms.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('terms_and_conditions'),
                    heading: i18n.t('terms_and_conditions'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            },
            {
                path: 'letters-of-authority',
                name: 'SystemDataEntryLettersOfAuthority',
                component: () => import('@/views/SystemDataEntryLettersOfAuthority.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('letters_of_authority'),
                    heading: i18n.t('letters_of_authority'),
                    permissions: [permissions.ANY_ORGANISATION_READ],
                    organisations: ['ADVISER'],
                    sidebarKey: 'system-data-entry-sidebar'
                }
            }
        ]
    },
    {
        path: '/system/bulk-import',
        name: 'SystemBulkImport',
        components: {
            default: () => import('@/views/SystemBulkImport.vue'),
            sidebar: () => import('@/components/sidebars/SystemBulkImportSidebar.vue')
        },
        meta: {
            overline: i18n.t('system'),
            title: i18n.t('bulk_import'),
            heading: i18n.t('bulk_import'),
            permissions: [permissions.BULK_IMPORT],
            organisations: ['ADVISER']
        },
        children: [
            {
                path: 'vct',
                name: 'SystemBulkImportVct',
                component: () => import('@/views/SystemBulkImportVct.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('vct_and_single_company'),
                    heading: i18n.t('vct_and_single_company'),
                    subheading: i18n.t('bulk_import'),
                    permissions: [permissions.BULK_IMPORT],
                    organisations: ['ADVISER']
                }
            },
            {
                path: 'related-organisations',
                name: 'SystemBulkImportRelatedOrganisations',
                component: () => import('@/views/SystemBulkImportRelatedOrganisations.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('related_organisations'),
                    heading: i18n.t('related_organisations'),
                    subheading: i18n.t('bulk_import'),
                    permissions: [permissions.BULK_IMPORT],
                    organisations: ['ADVISER']
                }
            },
            {
                path: 'funds',
                name: 'SystemBulkImportFunds',
                component: () => import('@/views/SystemBulkImportFunds.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('funds'),
                    heading: i18n.t('funds'),
                    subheading: i18n.t('bulk_import'),
                    permissions: [permissions.BULK_IMPORT],
                    organisations: ['ADVISER']
                }
            },
            {
                path: 'morningstar',
                name: 'SystemBulkImportMorningstar',
                component: () => import('@/views/SystemBulkImportMorningstar.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('morningstar'),
                    heading: i18n.t('morningstar'),
                    subheading: i18n.t('bulk_import'),
                    permissions: [permissions.BULK_IMPORT],
                    organisations: ['ADVISER']
                }
            },
            {
                path: 'investment-transactions',
                name: 'SystemBulkImportInvestmentTransactions',
                component: () => import('@/views/SystemBulkImportInvestmentTransactions.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('investment') + ' ' + i18n.t('transactions'),
                    heading: i18n.t('investment') + ' ' + i18n.t('transactions'),
                    subheading: i18n.t('bulk_import'),
                    permissions: [permissions.BULK_IMPORT],
                    organisations: ['ADVISER']
                }
            },
            {
                path: 'advisers',
                name: 'SystemBulkImportAdvisers',
                component: () => import('@/views/SystemBulkImportAdvisers.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('advisers'),
                    heading: i18n.t('advisers'),
                    subheading: i18n.t('bulk_import'),
                    permissions: [permissions.BULK_IMPORT],
                    organisations: ['ADVISER']
                }
            },
            {
                path: 'investors',
                name: 'SystemBulkImportInvestors',
                component: () => import('@/views/SystemBulkImportInvestors.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('investors'),
                    heading: i18n.t('investors'),
                    subheading: i18n.t('bulk_import'),
                    permissions: [permissions.BULK_IMPORT],
                    organisations: ['ADVISER']
                }
            },
            {
                path: 'valuations',
                name: 'SystemBulkImportValuations',
                component: () => import('@/views/SystemBulkImportValuations.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('valuations'),
                    heading: i18n.t('valuations'),
                    subheading: i18n.t('bulk_import'),
                    permissions: [permissions.BULK_IMPORT],
                    organisations: ['ADVISER']
                }
            },
            {
                path: 'documents',
                name: 'SystemBulkImportDocuments',
                component: () => import('@/views/SystemBulkImportDocuments.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('documents'),
                    heading: i18n.t('documents'),
                    subheading: i18n.t('bulk_import'),
                    permissions: [permissions.BULK_IMPORT],
                    organisations: ['ADVISER']
                }
            }
        ]
    },
    {
        path: '/system/debug',
        name: 'SystemDebug',
        component: () => import('@/views/SystemDebug.vue'),
        meta: {
            overline: i18n.t('system'),
            title: 'Debug',
            heading: 'Debug',
            permissions: [permissions.BULK_IMPORT],
            organisations: ['ADVISER']
        },
        children: [
            {
                path: '/system/debug/wysiwyg',
                name: 'SystemWysiwygDebugger',
                component: () => import('@/views/SystemWysiwygDebugger.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('wysiwyg_debugger'),
                    heading: i18n.t('wysiwyg_debugger'),
                    permissions: [permissions.BULK_IMPORT],
                    organisations: ['ADVISER']
                }
            },
            {
                path: '/system/debug/dynamic-form',
                name: 'SystemDynamicFormDebugger',
                component: () => import('@/views/SystemDynamicFormDebugger.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('dynamic_form_debugger'),
                    heading: i18n.t('dynamic_form_debugger'),
                    permissions: [permissions.BULK_IMPORT],
                    organisations: ['ADVISER']
                }
            },
            {
                path: '/system/debug/error',
                name: 'SystemErrorDebugger',
                component: () => import('@/views/SystemErrorDebugger.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('error_debugger'),
                    heading: i18n.t('error_debugger'),
                    permissions: [permissions.BULK_IMPORT],
                    organisations: ['ADVISER']
                }
            },
            {
                path: '/system/debug/proposal-calculation',
                name: 'SystemProposalCalculationDebugger',
                component: () => import('@/views/SystemProposalCalculationDebugger.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: 'Proposal Calculation Debugger',
                    heading: 'Proposal Calculation Debugger',
                    permissions: [permissions.BULK_IMPORT],
                    organisations: ['ADVISER']
                }
            },
            {
                path: '/system/debug/pdf',
                name: 'SystemPdfDebugger',
                component: () => import('@/views/SystemPdfDebugger.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: 'PDF Debugger',
                    heading: 'PDF Debugger',
                    permissions: [permissions.BULK_IMPORT],
                    organisations: ['ADVISER']
                }
            },
            {
                path: '/system/debug/chart',
                name: 'SystemChartDebugger',
                component: () => import('@/views/SystemChartDebugger.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: 'Chart Debugger',
                    heading: 'Chart Debugger',
                    permissions: [permissions.BULK_IMPORT],
                    organisations: ['ADVISER']
                }
            },
            {
                path: '/system/debug/mocks',
                name: 'SystemMocksDebugger',
                component: () => import('@/views/SystemMocksDebugger.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('mocks'),
                    heading: i18n.t('mocks'),
                    permissions: [permissions.BULK_IMPORT],
                    organisations: ['ADVISER']
                }
            }
        ]
    },
    {
        path: '/system/dynamic-form-builder',
        name: 'SystemDynamicFormBuilder',
        component: () => import('@/views/SystemDynamicFormBuilder.vue'),
        meta: {
            overline: i18n.t('system'),
            title: i18n.t('dynamic_form_builder'),
            heading: i18n.t('dynamic_form_builder'),
            permissions: [permissions.BULK_IMPORT],
            organisations: ['ADVISER']
        }
    },
    {
        path: '/system/icons',
        name: 'SystemIcons',
        component: () => import('@/views/SystemIcons.vue'),
        meta: {
            overline: i18n.t('system'),
            title: i18n.t('icons'),
            heading: i18n.t('icons'),
            permissions: [permissions.BULK_IMPORT],
            organisations: ['ADVISER']
        }
    },
    {
        path: '/system/remote-application-builder',
        name: 'RemoteApplicationBuilder',
        component: () => import('@/views/RemoteApplicationBuilder.vue'),
        meta: {
            overline: i18n.t('system'),
            title: i18n.t('remote_application') + ' ' + i18n.t('builder'),
            heading: i18n.t('remote_application') + ' ' + i18n.t('builder'),
            permissions: [permissions.BULK_IMPORT],
            organisations: ['ADVISER']
        }
    },
    {
        path: '/system/bulk-share-allotment',
        name: 'BulkShareAllotment',
        component: () => import('@/views/BulkShareAllotment.vue'),
        meta: {
            overline: i18n.t('system'),
            title: i18n.t('bulk_share_allotment'),
            heading: i18n.t('_page.bulk_share_allotment.heading'),
            description: i18n.t('_page.bulk_share_allotment.description'),
            permissions: [permissions.BULK_IMPORT],
            organisations: ['ADVISER']
        }
    },
    {
        path: '/system/dri-management',
        name: 'DriManagement',
        component: () => import('@/views/DriManagement.vue'),
        meta: {
            overline: i18n.t('system'),
            title: i18n.t('dri_management'),
            heading: i18n.t('_page.dri_management.heading'),
            description: i18n.t('_page.dri_management.description'),
            permissions: [permissions.BULK_IMPORT],
            organisations: ['ADVISER']
        }
    },
    {
        path: '/system/bulk-update',
        name: 'SystemBulkUpdate',
        component: () => import('@/views/SystemBulkUpdate.vue'),
        meta: {
            overline: i18n.t('system'),
            title: i18n.t('bulk_update'),
            heading: i18n.t('bulk_update'),
            permissions: [permissions.BULK_IMPORT],
            organisations: ['ADVISER']
        },
        children: [
            {
                path: 'offers',
                name: 'SystemBulkUpdateOffers',
                component: () => import('@/views/SystemBulkUpdateOffers.vue'),
                meta: {
                    overline: i18n.t('system'),
                    title: i18n.t('offers'),
                    heading: i18n.t('offers'),
                    subheading: i18n.t('bulk_update'),
                    permissions: [permissions.BULK_IMPORT],
                    organisations: ['ADVISER']
                }
            }
        ]
    }
];
